import { z } from "zod";

export const terminalAttendancesSchema = z.object({
	digits: z.string().length(4, "Digits must be 4 characters long"),
});

export type TerminalAttendancesSchema = z.infer<typeof terminalAttendancesSchema>;

/**
 * The body a terminal checks somebody in or out with: the PIN identifies the person, the two
 * acknowledgement fields carry what they confirmed on the way. The worksite is not in here — the
 * pairing carries it, so a device cannot book on a worksite it was not approved for.
 */
export const terminalCheckInSchema = terminalAttendancesSchema.extend({
	acknowledgedDefinitionIds: z.array(z.uuid()).optional(),
	acknowledgedRiskAssessments: z.boolean().optional(),
});

export type TerminalCheckInSchema = z.infer<typeof terminalCheckInSchema>;
